import focusLock from "dom-focus-lock";

export default class ImageCarousel {
	constructor(config) {
		this.el = config.el || document.querySelector(".carousel");
		this.dots = this.el.querySelectorAll(".carousel__dot");
		this.dotCurrentClass = "carousel__dot--current";
		this.slides = this.el.querySelectorAll(".carousel__slide");
		this.slidesLength = this.el.querySelectorAll(".carousel__slide").length;
		this.track = this.el.querySelector(".carousel__track");
		this.wrapper = this.el.querySelector(".carousel__wrapper");
		this.prevBtn = this.el.querySelector(".carousel__prev-btn");
		this.nextBtn = this.el.querySelector(".carousel__next-btn");
		this.clickOutside = this.el.querySelector(".carousel__click-outside");
		this.closeButton = this.el.querySelector(".carousel__close-button");
		this.showLargeButton = this.el.querySelector(
			".carousel__showlarge-button"
		);
		this.buttonDisabledClass = "button--disabled";
		this.showLargeClass = "carousel--show-large";

		this.currentSlide = 0;
		this.isgrabbing = false;
		this.isDown = false;
		this.startX;
		this.grabClass = "carousel--grabbing";
		this.scrollLeft;
		this.scrollDirection = null;
		this.showAsCarousel = this.slidesLength > 1;
		this.isCompact = this.el.classList.contains("carousel--compact");
		utilities.dataStorage.put(this.el, "component", this);
		this.caption = document.getElementById("carousel__caption");
		this.isSlideTabNavigationDisabled =
			this.el.getAttribute("data-disable-slide-tab-navigation") ===
			"true";
		this.init();
	}
	init() {
		this.el.classList.add("carousel--inited");
		if (!this.showAsCarousel) {
			this.el.classList.add("carousel--no-controls");
		}
		this.addEventListeners();

		if (this.showAsCarousel) {
			this.gotoSlide(0);
			this.setInactiveButtons(0);
			this.addAriaLiveElement();
			this.setCurrentDot(0);
			this.setAriaProps();
		}
	}
	addAriaLiveElement() {
		var liveregion = document.createElement("div");
		liveregion.setAttribute("aria-live", "polite");
		liveregion.setAttribute("aria-atomic", "true");
		liveregion.setAttribute("class", "liveregion visuallyhidden");
		this.el.appendChild(liveregion);
	}
	addEventListeners() {
		const self = this;
		if (this.showAsCarousel) {
			this.dots.forEach(dot => {
				dot.addEventListener("click", function(event) {
					const index = Array.from(dot.parentNode.children).indexOf(
						dot
					);
					self.gotoSlide(index);
				});
			});
			this.track.addEventListener("scroll", event => {
				var slideInView = self.getSlideInViewIndex();
				self.setCurrentDot(slideInView);
				self.setInactiveButtons(slideInView);
				self.setAriaProps();
				this.el.dispatchEvent(
					new CustomEvent("carousel/changeSlide", {
						detail: {
							index: slideInView
						}
					})
				);
			});
			this.prevBtn.addEventListener("click", e => {
				self.gotoPrevSlide();
			});
			this.nextBtn.addEventListener("click", e => {
				self.gotoNextSlide();
			});
		}

		this.slides.forEach(slide => {
			slide.addEventListener("click", function(event) {
				const index = Array.from(self.slides).indexOf(slide);
				self.showLarge(index);
			});
		});

		this.clickOutside.addEventListener("click", e => {
			self.hideLarge();
		});
		this.closeButton.addEventListener("click", e => {
			self.hideLarge();
		});
		if (this.showLargeButton) {
			this.showLargeButton.addEventListener("click", e => {
				self.showLarge(0);
			});
		}
		this.el.addEventListener("keydown", function(evt) {
			evt = evt || window.event;
			if (evt.keyCode == utilities.keys.escape) {
				if (self.el.classList.contains(self.showLargeClass)) {
					self.hideLarge();
				}
			}
			if (self.el.classList.contains("js-focus-within")) {
				//right arrow
				if (evt.keyCode == utilities.keys.rightarrow) {
					self.gotoNextSlide();
				}
				//left arrow
				if (evt.keyCode == utilities.keys.leftarrow) {
					self.gotoPrevSlide();
				}
			}
		});
		// this.addGrabEvents();
	}
	isWholeElementInViewport(el) {
		var bounding = el.getBoundingClientRect();

		if (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.right <= window.innerWidth &&
			bounding.bottom <= window.innerHeight
		) {
			return true;
		} else {
			return false;
		}
	}
	setAriaProps() {
		for (let i = 0; i < this.slides.length; i++) {
			if (this.isWholeElementInViewport(this.slides[i])) {
				if (!this.isSlideTabNavigationDisabled) {
					this.slides[i].tabIndex = "0";
				}
				let video = this.slides[i].querySelector("video");
				if (video && !this.isSlideTabNavigationDisabled) {
					video.tabIndex = "0";
				}
				utilities.setAriaProp(this.slides[i], "hidden", false);
				this.slides[i].classList.add("carousel__slide--visible");
			} else {
				utilities.setAriaProp(this.slides[i], "hidden", true);
				this.slides[i].classList.remove("carousel__slide--visible");
				this.slides[i].tabIndex = "-1";
				let video = this.slides[i].querySelector("video");
				if (video) {
					video.tabIndex = "-1";
				}
			}
		}
		const activeSlide = this.slides[this.currentSlide];
		utilities.setAriaProp(activeSlide, "hidden", false);
		if (!this.isSlideTabNavigationDisabled) {
			activeSlide.tabIndex = "0";
		}
	}
	showLarge(index) {
		const self = this;
		document.body.style.overflow = "hidden";
		focusLock.on(this.wrapper);
		this.el.classList.add(this.showLargeClass);
		this.wrapper.setAttribute("role", "dialog");
		// make sure that lazysizes updates the new width on image-elements
		window.lazySizes.autoSizer.checkElems();
		this.gotoSlide(index, 100, "instant");
		setTimeout(() => {
			self.closeButton.focus();
		}, 150);
		// }
	}
	hideLarge() {
		document.body.style.overflow = "auto";
		focusLock.off(this.wrapper);
		this.wrapper.removeAttribute("role");
		this.el.classList.remove(this.showLargeClass);
	}
	isLarge() {
		return this.el.classList.contains(this.showLargeClass);
	}
	addGrabEvents() {
		const self = this;
		this.el.classList.add("carousel--has-grab-events");
		this.track.addEventListener("mousedown", e => {
			self.isDown = true;
			self.track.classList.add(self.grabClass);
			self.startX = e.pageX - self.track.offsetLeft;
			self.scrollLeft = self.track.scrollLeft;
		});
		this.track.addEventListener("mouseleave", () => {
			if (!self.isDown) return;
			self.gotoSlide(self.getSlideInViewIndex());
			self.isDown = false;
			// self.track.classList.remove(self.grabClass);
		});
		this.track.addEventListener("mouseup", () => {
			self.isDown = false;
			self.gotoSlide(self.getSlideInViewIndex());
			// self.track.classList.remove(self.grabClass);
		});
		this.track.addEventListener("mousemove", e => {
			if (!self.isDown) return;
			this.isgrabbing = true;
			e.preventDefault();
			const x = e.pageX - self.track.offsetLeft;
			self.walk = x - self.startX; //scroll-fast
			self.track.scrollLeft = self.scrollLeft - self.walk;
		});
	}
	setInactiveButtons(index) {
		var maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
		if (this.track.scrollLeft == 0) {
			this.prevBtn.classList.add(this.buttonDisabledClass);
			this.prevBtn.disabled = true;
			this.nextBtn.classList.remove(this.buttonDisabledClass);
			this.nextBtn.removeAttribute("disabled");
		} else if (this.track.scrollLeft >= maxScrollLeft - 10) {
			this.nextBtn.classList.add(this.buttonDisabledClass);
			this.nextBtn.disabled = true;
			this.prevBtn.removeAttribute("disabled");
			this.prevBtn.classList.remove(this.buttonDisabledClass);
		} else {
			this.prevBtn.removeAttribute("disabled");
			this.prevBtn.classList.remove(this.buttonDisabledClass);
			this.nextBtn.removeAttribute("disabled");
			this.nextBtn.classList.remove(this.buttonDisabledClass);
		}
	}
	getSlideInViewIndex() {
		let index = 0;
		var maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;

		if (this.track.scrollLeft == 0) {
			//at first slide
			index == 0;
			// console.log("at begining");
		} else if (this.track.scrollLeft >= maxScrollLeft) {
			// console.log("at end");
			index = this.slidesLength - 1;
		} else {
			// in between
			// console.log("in between");
			index = Math.ceil(
				this.track.scrollLeft / (this.slides[0].scrollWidth + 10)
			);
		}
		this.currentSlide = index;
		return index;
	}
	gotoSlide(index, timeout = 0, behavior = "smooth") {
		const self = this;
		if (!this.slides[index]) {
			return;
		}
		// add figcaption text for carouselWithThumbnails
		if (this.caption) {
			const caption = this.caption;
			caption.innerHTML = this.slides[index].querySelector(
				"figcaption"
			).innerHTML;
		}

		this.track.classList.remove(self.grabClass);
		if (
			this.isCompact &&
			!this.el.classList.contains(this.showLargeClass)
		) {
			setTimeout(() => {
				self.track.scrollTo({
					top: 0,
					left: self.slides[index].offsetLeft,

					behavior
				});
			}, timeout);
		} else {
			setTimeout(() => {
				const slide = self.slides[index];
				self.track.scrollTo({
					top: 0,
					left: slide.offsetLeft + slide.offsetWidth / 2 - self.track.clientWidth / 2,
					behavior
				});
			}, timeout);
		}
	}
	resetCurrentDot() {
		const self = this;
		this.dots.forEach(dot => {
			dot.classList.remove(self.dotCurrentClass);
			utilities.setAriaProp(dot, "current", false);
		});
	}
	setCurrentDot(index) {
		if (index <= this.slidesLength - 1) {
			this.resetCurrentDot();
			const self = this;
			if (this.dots[index]) {
				this.dots[index].classList.add(self.dotCurrentClass);
				utilities.setAriaProp(this.dots[index], "current", true);
			}
		}
	}
	gotoPrevSlide() {
		if (this.isCompact) {
			this.gotoSlide(this.currentSlide - 1);
		} else {
			var firstSlideInViewIndex = 0;
			// get index of first slide thats in view
			for (let i = 0; i < this.slides.length; i++) {
				if (utilities.isElementInViewport(this.slides[i])) {
					firstSlideInViewIndex = i;
					break;
				}
			}
			if (firstSlideInViewIndex > 0) {
				this.gotoSlide(firstSlideInViewIndex - 1);
			}
		}
	}
	gotoNextSlide() {
		if (this.isCompact) {
			this.gotoSlide(this.currentSlide + 1);
		} else {
			var lastSlideInViewIndex = 0;
			// get index of first slide thats in view
			for (let i = this.slides.length - 1; i >= 0; i--) {
				if (utilities.isElementInViewport(this.slides[i])) {
					lastSlideInViewIndex = i;
					break;
				}
			}
			if (lastSlideInViewIndex < this.slides.length - 1) {
				this.gotoSlide(lastSlideInViewIndex + 1);
			}
		}
	}
}
